/* eslint-disable */
import { Mesh } from 'three';

import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils';

import EleganceDoor from '../Elegance/Base';

import { getRGBFromRAL, metalMat, pinewoodFrameMat } from '../Materials';

// const mediaBucketUrl = process.env.NEXT_PUBLIC_MEDIA_BUCKET_URL;

export default class ModernDoor extends EleganceDoor {
  constructor(...args) {
    super(...args);

    const attributes = args[0];

    //  load the key resources
    this.resourceManager.loadResources(
      ['handleInner', 'simpleSystem', 'hamakSystem', 'hiddenSystem'],
      () => {
        this.update(attributes);
        this.renderFunc();
      }
    );

    //  Define the materials
    this.materialDefinitions = {
      metal: { ...metalMat },
      woodBody: {
        metalness: 0.3,
        roughness: 0.6,
      },
      woodFrame: { ...pinewoodFrameMat },
    };

    this.parameters.handle = true;

    this.initMaterials();
    this.update(attributes);
  }

  updateModelParameters(attributes) {
    //  Set the parameters
    const doorStyle = attributes['door-style']
      ? attributes['door-style']
      : 'density-1';
    const styleParams = doorStyle.split('-');
    this.parameters.style = styleParams[0];
    this.parameters.density = parseInt(styleParams[1], 10) || 0;

    // Set the new texture
    const doorColor = attributes['door-color']
      ? attributes['door-color']
      : attributes['door-color-paint']
      ? attributes['door-color-paint']
      : 'pinewood_ral9010';

    const colorParams = doorColor.split('_');
    this.parameters.color = doorColor;
    const systemColor = attributes['system-color']
      ? attributes['system-color']
      : 'system-simple-black';
    const systemcolorParams = systemColor.split('-');
    this.parameters.systemColor = systemColor;
    this.parameters.system = systemcolorParams[1];
    this.materialDefinitions.woodFrame.color = getRGBFromRAL(colorParams[1]);
    this.materialDefinitions.woodBody.color = getRGBFromRAL(colorParams[1]);
    this.materialDefinitions.metal.color = getRGBFromRAL(
      systemcolorParams[systemcolorParams.length - 1]
    );

    this.updateMaterial(
      this.materials.woodFrame,
      this.materialDefinitions.woodFrame
    );
    this.updateMaterial(
      this.materials.woodBody,
      this.materialDefinitions.woodBody
    );
    this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
  }

  buildModel() {
    const Frame = this.buildFrameGeometry();
    const Body = this.buildBodyGeometry();
    const Handle = this.buildHandleGeometry();
    const Hanger = this.buildHangerGeometry();
    if (Frame) {
      this.group.add(
        new Mesh(
          BufferGeometryUtils.mergeGeometries(Frame),
          this.materials.woodFrame
        )
      );
    }
    if (Body) {
      this.group.add(
        new Mesh(
          BufferGeometryUtils.mergeGeometries(Body),
          this.materials.woodBody
        )
      );
    }
    Handle.forEach((geometry) => {
      this.group.add(new Mesh(geometry, this.materials.metal));
    });
    Hanger.forEach((geometry) => {
      this.group.add(new Mesh(geometry, this.materials.metal));
    });

    this.group.children.forEach((z) => {
      z.castShadow = true;
      z.receiveShadow = true;
    });

    this.group.position.y = -38;
  }
}
